import { render, staticRenderFns } from "./Markdown.vue?vue&type=template&id=008764db&"
import script from "./Markdown.vue?vue&type=script&lang=js&"
export * from "./Markdown.vue?vue&type=script&lang=js&"
import style0 from "./Markdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports